import { render, staticRenderFns } from "./TabPricing.vue?vue&type=template&id=e0af34aa&"
import script from "./TabPricing.vue?vue&type=script&lang=js&"
export * from "./TabPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports